/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1OrganizationMemberState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ORGANIZATION_MEMBER_STATE_ENTITY_NAME = 'ixm.userauth.v1.OrganizationMember';
export const ixmUserauthV1OrganizationMemberStateEntity = new schema.Entity<IxmUserauthV1OrganizationMemberState>(IXM_USERAUTH_V1_ORGANIZATION_MEMBER_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1OrganizationMemberState) => `${entity.userId}-${entity.organizationId}` });

